/** This is a generic find function where the object's values can be typed as any */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();function find(key: string, obj: { [key: string]: any }): object | null {
  let result = null;
  for (const k in obj) {
    if (k === key) {
      result = obj[k]
    } else if (typeof obj[k] === 'object' && obj[k] !== null) {
      const value = find(key, obj[k]);
      if (value !== undefined && value !== null) {
        result = value
      }
    }
  }
  return result;
}

export { find };
